export default __webpack_public_path__ + "static/media/hm-pp-img.67783feb.webp";